import React, { useState, useEffect } from "react";
// import './style.scss';
import { LoadingOutlined } from "@ant-design/icons";
import { Layout, Table, Checkbox, Button, Space, PageHeader, Modal, message } from 'antd';
import MenuForm from './menu-item-form';
import DashboardService from "../../services/DashboardService";
import MenuService from "../../services/MenuService";
import R2Footer from "../../components/Footer";
import { useHistory, useParams } from "react-router";
import _ from 'lodash';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MenuItemCard from "./MenuItemCard";
import SectionCard from "./sectionCard";
import AddCard from "./addCard";
import AddItem from "./addItem";
import styles from './style.module.scss';
import AllItems from "./allItems";
import MenuSetting from "../../services/menuSetting";
import KdsStationService from "../../services/kdsStationService";
import FileImport from "./fileImort";

const { Content } = Layout;

const MenuSection = (props) => {
    const params = useParams();
    const initialValue = {
        "is_vegetarian": false,
        "is_vegan": false,
        "is_gluten_free": false,
        "has_dairy": false,
        "has_nuts": false,
        "menu_id": parseInt(params.menuId),
        // "restaurant_id": props.adminRestaurant,
        "description": "",
        "calories": 0,
        size:"1",
        // "menu_group_id": 8,
        prep_time_minutes: 1,
        is_active: true,
        ingredients:[],
        attributes:[{
            "type": "",
            "value": "",
            "description": ""
        }]
    };
    const defaultSetting = {
        "apply_gratuity_on_party_greater_than": 1,
        "gratuity_amount": 1,
        "allow_spice_level": false,
        "allow_dairy": false,
        "allow_nuts": false,
        "allow_vegetarian": false,
        "allow_description": false,
        "allow_calories": false,
        "allow_gluten_free": false,
        "allow_vegan": false
      };
    const [settingsList, setSettingsList ] = useState(defaultSetting);
    const [loading, setLoading] = useState(true);
    const [addNewSec, setAddNewSec] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [expandId, setExpandId] = useState([]);
    const [menuDetails, setMenuDetails] = useState({});
    const [isEditing, setIsEditing] = useState(false);
    const [secEdit, setSecEdit] = useState({});
    const [newItem, setNewItem] = useState(initialValue);
    const itemField = ['photo_url', 'name', 'maximum_order_quantity', 'minimum_order_quantity', 'price'];
    const [newCard, setNewCard] = useState({photo_url:'', name:''});
    const [allIngredient, setAllIngredient] = useState([])
    const [allCourses, setAllCourses] = useState([]);
    const [allKdsStation, setAllKdsStation] = useState([]);
    const [showImport, setShowImport] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [uploading, setUploading] = useState(false);
    const history = useHistory();
    const [messageApi, contextHolder] = message.useMessage();

    const getmenuDetails = async() => {
        const Details = await MenuService.getMenu(parseInt(params.menuId));
        setLoading(false);
        setMenuDetails(Details);
    };
    const getIngredients = async() => {
        const ingredient = await MenuService.getIngredients(props.adminRestaurant);
        setAllIngredient(ingredient);
    };
    const getCourses = async () => {
       const courseData = await MenuSetting.getMenuCourse(props.adminRestaurant);
       setAllCourses(courseData);
    };
    const getKdsStation = async() => {
        const kdsStations = await KdsStationService.getStationData(props.adminRestaurant);
        setAllKdsStation(kdsStations);
    };
    const validateItemFields = () => {
        let emptyField = false;
        itemField.map((iField)=>{
            if(!newItem[iField]){
                emptyField = true;
            }
            return null;
        });
        return emptyField;
    };
    useEffect(() => {
        MenuService.menugroupById();
        getmenuDetails()
    }, [])

    useEffect(()=>{
        getIngredients();
        getKdsStation();
        getCourses();
        MenuSetting.getRestaurentSettings(props.adminRestaurant).then((res)=>{
            if(res?.restaurant_id){
                setSettingsList(res);
            } else {
                setSettingsList(defaultSetting);
            }
        });
    }, [props.adminRestaurant]);
    const handleCancel = () => {
        setShowAdd(false);
    };
    const onAddItem = (secData) => {
        setShowAdd(secData);
        if(secData.id){
            const newItemList = { ...newItem }
            newItemList.menu_group_id = secData.id;
            setNewItem(newItemList);
        }
    };
    const onAddGroup = async () => {
        if(newCard.name && newCard.photo_url){
        const newSec = await MenuService.addSection({
        name: newCard.name,
        photo_url:newCard.photo_url, description:'',
        "menu_id": parseInt(params.menuId),
        "is_combo_pack": false,
        "is_vegetarian": false,
        "is_vegan": false,
        "is_gluten_free": false
    });
        getmenuDetails();
        setAddNewSec(false);
    } else {
        messageApi.open({type: 'error', content: 'Please enter section name and upload image', duration: 1 });
    }
    };
    const submitForm = async(showRedirect) => {
        if(validateItemFields()){
            messageApi.open({type: 'error', content: 'Please fill all the fields', duration: 1 });
        }else {
            if(isEditing){
                const itemList = {...newItem};
                delete itemList.id;
                delete itemList.created_at;
                delete itemList.updated_at;
                itemList.etd_minutes = 1;
                itemList.kds_station_id = itemList.kds_station_id ?? 1;
                // itemList.restaurant_id = props.adminRestaurant;
                itemList.has_dairy = itemList.has_dairy || false;
                itemList.has_nuts = itemList.has_nuts || false;
                itemList.calories = itemList.calories || 0;
                itemList.ordinality = itemList.ordinality || 0;
                itemList.spice_level = itemList.spice_level || "LOW";
                itemList.ingredients = itemList.ingredients || [];
                itemList.prep_time_minutes = itemList.prep_time_minutes || 0;
                const updateItemRes = await MenuService.updateMenuItem(itemList, newItem.id);
                if(updateItemRes?.data){
                    messageApi.open({type: 'success', content: 'Item Saved Successfully', duration: .5 });
                    if(showRedirect){
                        history.push(`/menu/customization?menu=${params.menuId}&group=${updateItemRes?.data.menu_group_id}&item=${newItem.id}`);
                    }
                } else {
                    messageApi.open({type: 'error', content: 'Something went wrong', duration: .5 });
                }
            } else {
                const itemData = {...newItem};
                // itemData.restaurant_id = props.adminRestaurant;
                const newItemRes = await MenuService.addMenuItem(itemData);
                if(newItemRes?.data){
                    messageApi.open({type: 'success', content: 'Item Saved Successfully', duration: .5 });
                    if(showRedirect){
                        history.push(`/menu/customization?menu=${params.menuId}&group=${newItemRes?.data.menu_group_id}&item=${newItemRes?.data?.id}`);
                    }
                } else {
                    messageApi.open({type: 'error', content: 'Something went wrong', duration: .5 });
                }
            }
            getmenuDetails();
            setShowAdd(false);
            setIsEditing(false);
            setNewItem(initialValue);
            getIngredients();
        }
    };
    const onDeleteConfirmItem = async(id) => {
        await MenuService.deleteMenuItem(id);
        messageApi.open({type: 'success', content: 'Deleted Successfully', duration: .5 });
        getmenuDetails();
    };
    const onDeleteItem = async(id) => {
        Modal.confirm({
            title: 'Are you sure',
            content: 'Do you want to delete the menu item?',
            okText: 'Delete',
            cancelText: 'Cancel',
            onOk: ()=> onDeleteConfirmItem(id)
          });
    };
    const onDeleteGroupConfirm = async(id) => {
        await MenuService.deleteMenuGroup(id);
        messageApi.open({type: 'success', content: 'Deleted Successfully', duration: .5 });
        getmenuDetails();
    };
    const onDeleteGroup = async(id) => {
        Modal.confirm({
            title: 'Are you sure',
            content: 'Do you want to delete the menu group?',
            okText: 'Delete',
            cancelText: 'Cancel',
            onOk: ()=> onDeleteGroupConfirm(id)
          });
    };
    const onEditItem = async(item) => {
        const menuItem = await MenuService.getMenuItem(item.id);
        const selectedData = {...menuItem};
        selectedData.ingredients = menuItem.ingredients.map((itm)=> itm.name);
        delete selectedData.menu;
        delete selectedData.attributes;
        setNewItem(selectedData);
        setShowAdd(true);
        setIsEditing(true);
    };
    const onEditGroup = (group) =>{
        setSecEdit(group);
    };
    const onUpdateGroup = async() => {
        let editedData = { ...secEdit} ;
        delete editedData.id;
        delete editedData.created_at;
        delete editedData.updated_at;
        delete editedData.menu_items
        let a = await MenuService.updateMenuGroup(editedData, secEdit.id);
        setSecEdit({});
        messageApi.open({type: 'success', content: 'Menu group updated successfully', duration: .5 });
        getmenuDetails();
    };
    const handleUpload = () =>{
        const formData = new FormData();
        formData.append("file", fileList[0]);
        MenuService.uploadMenuItemCsv(parseInt(params.menuId), formData).then((res)=>{
            if(res){
                getmenuDetails();
                setFileList([]);
                setShowImport(false);
                message.success('Menu item imported successfully')
            }
        });
    };
    const cancelImport = () => {
        setShowImport(false);
        setFileList([]);
    }
    return (
        <Layout style={{ padding: '0 24px 24px', background: "transparent" }}>
            {contextHolder}
            <Content
                style={{
                    padding: 24,
                    margin: '16px 0px',
                    minHeight: 280,
                }}
            >
                {
                    loading ?
                        <LoadingOutlined style={{ fontSize: '30px' }} />
                        :
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <PageHeader
                            className="page-header d-flex items-center"
                                title={<div className={styles.heading_text}>{params.menuName ? (params.menuName + " - Menu Items") : "Lunch / Menu sections and items"}</div>}
                                onBack={() => history.goBack()}
                                extra={[
                                    <>
                                    {addNewSec ? <div className={styles.save_sec}>
                                        <Button type="primary" style={{marginRight: 10}} onClick={()=>{ onAddGroup(); }}>Save</Button>
                                        <Button type="primary" className={styles.sec_cancel} onClick={()=>{ setAddNewSec(false); }}>Cancel</Button>
                                        </div>
                                    : <>
                                    <Button danger onClick={()=>{ setShowImport(true) }}>Bulk Edit Items</Button>
                                    <Button type="primary" onClick={()=>{ setAddNewSec(true); }}>Add New Section</Button>
                                    </>}
                                    </>

                                ]} />
                            {addNewSec && <AddCard setNewCard={setNewCard} newCard={newCard} />}
                                {/* <SectionCard setShowAdd={setShowAdd} /> */}
                            {/* { menu_items.map(menuItem => (
                                <SectionCard setShowAdd={setShowAdd}  setExpandId={setExpandId} expandId={expandId} key={menuItem.id} menuItem={menuItem} menuGroupsDetails={menuDetails} />
                            ))
                            } */}
                            <AllItems allData={menuDetails?.menu_groups || []} otherItem={menuDetails?.other_menu_items || []} setExpandId={setExpandId} expandId={expandId} onEditItem={onEditItem} onDeleteItem={onDeleteItem} settingsList={settingsList}  />
                            { menuDetails?.menu_groups?.map(menuItem => (
                                <SectionCard onAddItem={onAddItem}  setExpandId={setExpandId} expandId={expandId} key={menuItem.id}
                                 menuItem={menuItem} menuGroupsDetails={menuDetails} onDeleteItem={onDeleteItem} 
                                 onDeleteGroup={onDeleteGroup}
                                 onEditItem={onEditItem}
                                 onEditGroup={onEditGroup}
                                 setSecEdit={setSecEdit}
                                 secEdit={secEdit}
                                 onUpdateGroup={onUpdateGroup}
                                 settingsList={settingsList}
                                />
                            ))
                            }
                            {/* { menu_items.map(menuItem => (
                                <MenuItemCard key={menuItem.id} menuItem={menuItem} />
                            ))
                            } */}
                            <Modal className="modal_close" footer={null} visible={showAdd} width="820px" onOk={handleCancel} onCancel={handleCancel}>
                                <AddItem 
                                 setNewItem={setNewItem} 
                                 newItem={newItem}
                                 menuDetails={menuDetails} 
                                 submitForm={submitForm} 
                                 showAdd={showAdd} 
                                 settingsList={settingsList} 
                                 allIngredient={allIngredient} 
                                 allCourses={allCourses}
                                 allKdsStation={allKdsStation}
                                 />
                            </Modal>
                            <Modal className="" footer={null} title="Upload" visible={showImport} onCancel={()=>cancelImport(false)} onOk={()=>cancelImport(false)}>
                                <FileImport 
                                    setFileList={setFileList}
                                    fileList={fileList}
                                    setUploading={setUploading}
                                    uploading={uploading}
                                    handleUpload={handleUpload}
                                />
                            </Modal>
                        </Space>
                }
            </Content>
            <R2Footer />
        </Layout>
    )
}

const mapStateToProps = state => {
    return {
        adminRestaurant: state.admin,
    };
};
export default withRouter(connect(
    mapStateToProps
)(MenuSection));
